export default "/kiban/_next/static/images/bottom_black-aefb5dd93de7bc09505cf0d37f2ded2e.png";